import { createWebHistory, createRouter } from "vue-router";

const history = createWebHistory();
const router = createRouter({
  history,
  linkActiveClass: "active-nav",
  linkExactActiveClass: "exact-active-nav",
  routes: [
    {
      path: "/:pathMatch(.*)*",
      component: () => import("../pages/Dashboard.vue"),
    },
    {
      path: "/bridge",
      name: "bridge",
      component: () => import("../pages/Bridge.vue"),
    },
    // {
    //   path: "/:pathMatch(.*)*",
    //   component: () => import("../pages/ComingSoon.vue"),
    // },
  ],
});

export default router;
